import React from "react";
import "./style.css";
import img1 from "../../Assets/Team/od.jpeg";
import img2 from "../../Assets/Team/eod.jpeg";
import img3 from "../../Assets/Team/om.jpeg";
import IT from "../../Assets/Team/it.png";
import HR from "../../Assets/Team/hr.png";
import SUR from "../../Assets/Team/sur.png";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

const teamMembers = [
    {
        role: "OPERATIONS DIRECTOR",
        name: "MUHAMMAD HAFIZ BIN MAMOD RASIP",
        img: img1,
        summary: "Muhammad Hafiz Bin Mamod Rasip has over 11 years of experience in uniformed services, including the Singapore Armed Forces and Singapore Police Force. He has expertise in operations management, investigations, team leadership, and inter-agency coordination. Hafiz has held senior operational roles, overseeing daily unit operations, manpower deployment, and operational readiness. He has also led audits, managed projects, and supported staff development and innovation initiatives. Earlier, he served as a Team Leader and Senior Investigation Officer, ensuring security, incident response, and high team performance."
    },
    {
        role: "DEPUTY OPERATIONS DIRECTOR ",
        name: "TEO CHIN KEONG ",
        img: img2,
        summary: "Mr. Teo Chin Keong has 30 years of combined experience in uniformed and private security, including 20 years with the Ministry of Home Affairs/Internal Security Department. He served in operational and leadership roles, attaining the rank of Senior Staff Sergeant and Assistant Team Leader for a special squad. His responsibilities included mission planning, investigations, counter-terrorism operations, and international joint exercises. After government service, he accumulated 10 years in private security, managing major sites and ensuring operational efficiency. Currently, he oversees daily operations across more than 120 sites, focusing on manpower readiness and service excellence."
    },
    {
        role: "OPERATIONS  MANAGER",
        name: "JAY AATHITHEYAN",
        img: img3,
        summary: "Mr. Jay Aathitheyan is a seasoned security professional with 17 years of experience in Security Management, Manpower Deployment, Project Management, and Security Events Management. He excels at designing security strategies, optimizing workforce allocation, and managing large-scale projects, including 80-personnel operations for DHL. Jay has proven expertise in leading security operations, mitigating risks, and coordinating high-profile events. He also has experience in monitoring systems and command center operations. His skills ensure organizational safety, compliance, and operational efficiency."
    },
];

const Team = () => {
    return (
        <>
            <Navbar />
            <div className="team-container">
                <div className="team-wrapper">
                    <div className="team-left">
                        <h2>— OUR TEAM —</h2>
                        <p>
                            We are a strong and skilled team of 168 security officers and management staff, structured to handle every aspect of security operations efficiently. Our HR team ensures smooth coordination and personnel management, while the IT team manages technology, surveillance, and system integrations. The CCTV installation team monitors and maintains all surveillance systems, and our operations team oversees day-to-day security and emergency response. Every member is trained, professional, and committed to excellence. The management team coordinates strategy, planning, and training programs to ensure the highest standards.
                        </p>
                        <h4> <i>Together, we deliver comprehensive, trustworthy, and reliable security solutions, keeping people and assets safe at all times.</i></h4>
                    </div>

                    {/* Right Section */}
                    <div className="team-right">
                        {teamMembers.map((member, index) => (
                            <div className="team-card" key={index}>
                                <div className="card-text">
                                    <h3>{member.name}</h3>
                                    <span>{member.role}</span>
                                    <p>{member.summary}</p>

                                </div>

                                {/* CUT-OUT CIRCLE */}
                                <div className="profile-circle">
                                    <img src={member.img} alt={member.role} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="teams-section">

                {/* HR Team - image left, content right */}
                <div className="team-row">
                    <div className="team-image">
                        <img src={HR} alt="HR Team" />
                    </div>
                    <div className="team-content">
                        <h3>HR Team</h3>
                        <p>The HR Team is a strong and dedicated unit managing salary, payroll, and employee benefits. They ensure smooth communication between officers and management. They coordinate training, staff development, and workforce planning. The team also handles recruitment, performance monitoring, and employee engagement. Together, they keep the organization running efficiently and maintain high team morale.</p>
                    </div>
                </div>

                {/* IT Team - content left, image right */}
                <div className="team-row reverse">
                      <div className="team-image">
                        <img src={IT} alt="IT Team" />
                    </div>
                    <div className="team-content">
                        <h3>IT Team</h3>
                        <p>The IT Team is a skilled and versatile unit managing all technology and digital operations. They handle system maintenance, software, network support. They also support digital tools, marketing technology, and operational data systems. The team ensures smooth communication between departments and efficient workflow. Together, they enable the organization to run securely and efficiently in a tech-driven environment.</p>
                    </div>
                  
                </div>

                {/* Surveillance Team - image left, content right */}
                <div className="team-row">
                    <div className="team-image">
                        <img src={SUR} alt="Surveillance Team" />
                    </div>
                    <div className="team-content">
                        <h3>Surveillance Team</h3>
                        <p>The Surveillance Team is a highly skilled unit responsible for installing, monitoring, and maintaining all CCTV systems. They ensure real-time security coverage across all sites and support operational teams. The team manages surveillance equipment, performs regular checks, and handles incident reporting. They coordinate closely with management and other teams to maintain safety standards. Together, they provide reliable security and protect people and assets efficiently.</p>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default Team;
